import { render, staticRenderFns } from "./ReportPatient.vue?vue&type=template&id=886a5eda&scoped=true"
import script from "./ReportPatient.vue?vue&type=script&lang=js"
export * from "./ReportPatient.vue?vue&type=script&lang=js"
import style0 from "./ReportPatient.vue?vue&type=style&index=0&id=886a5eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886a5eda",
  null
  
)

export default component.exports